import React, { Component } from 'react';
import { CSSTransition } from 'react-transition-group';

import './card.scss';

import Icons from '../svg-icons';
import ArrowSvg from '../svg-icons/arrow';
import CornerSvg from '../svg-icons/corner';
import SpeakerSvg from '../svg-icons/speaker';


export default class Card extends Component {
  getCardBack = () => {
    const { cardId, cardTheme, cardTitle } = this.props.cardData;
    const CardIcon = Icons[`Icon${cardId}`];

    return (
      <React.Fragment>
        <div className="card-head back">
          <div className="card-head-img">
            <span className="corner-img">
              <CornerSvg />
            </span>
            <span className="card-icon">
              <CardIcon iconColor={'white'} />
            </span>
          </div>
          <div className="card-head-title">{cardTitle}</div>
        </div>

        <div className="card-inner">
          <div className="card-theme">
            {cardTheme}
            <div className="theme-arrow" onClick={this.handleArrowClick}>
              <ArrowSvg iconWidth={'30px'} iconHeigth={'30px'} />
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
  handleArrowClick = () => {
    this.props.flipCard();
  }
  getCardFront = () => {
    const { cardId, cardTitle, cardQuestions } = this.props.cardData;
    const CardIcon = Icons[`Icon${cardId}`];

    const questions = []
    for (const [idx, question] of cardQuestions.entries()) {
      questions.push(
      <li className="card-question-item" key={idx}>
        <SpeakerSvg/>
        {question}
        </li>
      );
    }
    return (
      <div className="card-inner">

        <div className="card-head face">
          <div className="card-head-img">
            <CardIcon iconColor={'#1CB6CC'} />
          </div>
          <div className="card-head-title">{cardTitle}</div>
        </div>

        <div className="card-body">
          {questions}
        </div>

      </div>
    )
  }

  render() {
    const cardBody = this.props.isFlipped ? this.getCardFront() : this.getCardBack();
    
    return (
        <CSSTransition
          unmountOnExit
          in={this.props.in}
          timeout={{ appear: 0, enter: 300, exit: 300 }}
          classNames='card'
          appear
          key={this.props.isFlipped}
        >
          <div className="card">
            {cardBody}
          </div>
        </CSSTransition>
    )
  }
}